// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_a8i","cls2":"FocusedNav-cls2_18h FocusedNav-cls1_a8i"};